import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./styles/app.scss";
import i18n from "./i18n";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { installProblemLog } from "./modules/problem-log";

const app = createApp(App)
  .use(store)
  .use(router)
  .use(i18n)
  .component("v-select", vSelect);

// Before mount: an error thrown during the first render is exactly the kind
// nobody can report afterwards.
installProblemLog(app);

app.mount("#app");
